import { TFunction } from 'i18next';
import { HealthSystemDALEnumsTemperatureUnit } from '../api/HealthSystemApi';

export function getTemperatureUnitLabel(
  unit: HealthSystemDALEnumsTemperatureUnit | null | undefined,
  t?: TFunction
): string {
  if (unit === 1) return t ? t('Fahrenheit') : '°F';
  return t ? t('Celsius') : '°C';
}

export function getTemperatureUnitOptions(t?: TFunction) {
  return [
    { value: 0 as HealthSystemDALEnumsTemperatureUnit, label: t ? t('Celsius') : 'Celsius' },
    { value: 1 as HealthSystemDALEnumsTemperatureUnit, label: t ? t('Fahrenheit') : 'Fahrenheit' }
  ];
}
